import {getCurrentStage} from "../common/config.ts";

const responseType = 'code' as const;
const provider = 'Google' as const;

const demoConfig = {
  // REQUIRED - Amazon Cognito Region
  region: 'eu-west-1',

  // OPTIONAL - Amazon Cognito User Pool ID
  userPoolId: 'eu-west-1_X5urGTi8u',

  // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
  userPoolClientId: '72jote3g3snujvbeg27mrjdqbf',

  loginWith: {
    oauth: {
      domain: "auth.demo.fantasytowngenerator.com",
      scopes: ["email", "profile", "openid"],
      redirectSignIn: ["http://localhost:3000/user/settlements"],
      redirectSignOut: ["http://localhost:3000"],
      responseType,
      providers: [provider],
      customOauthRedirectUri: 'http://localhost:3000/oauth/receiver.html',
    }
  },
};

const prodConfig = {
  // REQUIRED - Amazon Cognito Region
  region: 'eu-west-1',

  // OPTIONAL - Amazon Cognito User Pool ID
  userPoolId: 'eu-west-1_GRIi1BmV1',

  // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
  userPoolClientId: '4sjngg6g5r8dnaa6rm03von3du',

  loginWith: {
    oauth: {
      domain: "auth.fantasytowngenerator.com",
      scopes: ["email", "profile", "openid"],
      redirectSignIn: ["https://www.fantasytowngenerator.com/user/settlements"],
      redirectSignOut: ["https://www.fantasytowngenerator.com"],
      responseType,
      providers: [provider],
      customOauthRedirectUri: 'https://www.fantasytowngenerator.com/oauth/receiver.html',
    }
  },
};


export const cognitoConfig = getCurrentStage() === 'prod'
  ? prodConfig
  : demoConfig;
